'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RequestFactory = function () {
    function RequestFactory($q, urlConfig) {
        _classCallCheck(this, RequestFactory);

        this.$q = $q;
        this.urlConfig = urlConfig;
    }

    _createClass(RequestFactory, [{
        key: 'request',
        value: function request(config) {

            for (var i = 0; i < this.urlConfig.EXCLUDE_BEGIN.length; i += 1) {
                if (config.url.indexOf(this.urlConfig.EXCLUDE_BEGIN[i]) === 0) {
                    return config || this.$q.when(config);
                }
            }
            for (var i = 0; i < this.urlConfig.EXCLUDE_END.length; i += 1) {
                if (config.url.lastIndexOf(this.urlConfig.EXCLUDE_END[i]) === config.url.length - this.urlConfig.EXCLUDE_END[i].length) {
                    return config || this.$q.when(config);
                }
            }
            config.url = this.urlConfig.HOST_API + config.url;

            console.log("intercepting");
            console.log(config);
            return config || this.$q.when(config);
        }
    }]);

    return RequestFactory;
}();

RequestFactory.$inject = ['$q', 'urlConfig'];

exports.default = RequestFactory;


// WEBPACK FOOTER //
// ./src/busqueda/interceptores/request.factory.js